export const doctor = {
  uz: {
    meetDoctorsTitle: "<span>Bizning vrachlarimiz</span> bilan tanishing",
    meetDoctorsText: "Minglab bemorlar ishonchiga ega, professionallar guruhi",
    choriqulshaymatovName: "Shaymatov Choriqul Ibodullayevich",
    choriqulshaymatovSpec: "Klinika asoschisi va direktori",
    mirzaevilyosName: "Mirzaev Ilyosbek Ibodullayevich",
    mirzaevilyosSpec: "Klinika bosh vrachi",
    atayevShName: "Atayev Shuxratjon Xasanovich",
    atayevShSpec: "Lazer jarrohi",
    doctorTitle: "Sizning ko'rishingiz professionallar qo'lida",
    meetDoctorsLinkText: "Barcha shifokorlarni ko'rish",
    ganievShName: "Ganiyev Sherzod Djurakulovich",
    ganievShSpec: "Keratorefraktsiyon jarroh",
    oripovOName: "Oripov Oybek Ulug’bekovich",
    oripovOSpec: "Keratorefraktsiyon jarroh",
    oripovaYName: "Oripova Yoqutxon Choriqulovna",
    oripovaYSpec: "Vrach oftalmolog",
    eshniyozovZarifName: "Eshniyozov Zarifjon Shuxrat o’g’li",
    eshniyozovZarifSpec: "Vrach oftalmolog",
    xasanovJasurName: "Hasanov Jasur Ikromovich",
    xasanovJasurSpec: "Vrach oftalmolog",
    ibodullayevBektoshName: "Ibodullayev Bektosh Choriqul o’g’li",
    ibodullayevBektoshSpec: "Vrach oftalmolog",
  },
  ru: {
    meetDoctorsTitle: "Познакомьтесь с <span>нашими врачами</span>",
    meetDoctorsText:
      "Команда профессионалов, которым доверяют тысячи пациентов",
    choriqulshaymatovName: "Шайматов Чориқул Ибодуллаевич",
    choriqulshaymatovSpec: "Основатель и директор клиники",
    mirzaevilyosName: "Мирзаев Илёсбек Ибодуллаевич",
    mirzaevilyosSpec: "Главной врач клиники",
    atayevShName: "Атаев Шухратжон Хасанович",
    atayevShSpec: "Лазерный хирург",
    doctorTitle: "Ваше зрение в руках профессионалов",
    meetDoctorsLinkText: "Посмотреть всех врачей",
    ganievShName: "Ганиев Шерзод Джуракулович",
    ganievShSpec: "Кераторефракционный хирург",
    oripovOName: "Орипов Ойбек Улугбекович",
    oripovOSpec: "Кераторефракционный хирург",
    oripovaYName: "Орипова Ёқутхон Чориқуловна",
    oripovaYSpec: "Врач офтальмолог",
    eshniyozovZarifName: "Эшниёзов Зарифжон Шухрат ўгли",
    eshniyozovZarifSpec: "Врач офтальмолог",
    xasanovJasurName: "Хасанов Жасуржон Икромович",
    xasanovJasurSpec: "Врач офтальмолог",
    ibodullayevBektoshName: "Ибодуллаев Бектош Чориқул ўғли",
    ibodullayevBektoshSpec: "Врач офтальмолог",
  },
  tj: {
    meetDoctorsTitle: "Бо <span>Духтурони Мо</span> шинос шавед",
    meetDoctorsText:
      "Ҳоло ман ҳамшираи шафқат ҳастам, аммо ҳамшираи шафқат ҳастам",
    choriqulshaymatovName: "Шайматов Чориқул Ибодуллаевич",
    choriqulshaymatovSpec: "Основатель и директор клиники",
    mirzaevilyosName: "Мирзаев Илёсбек Ибодуллаевич",
    mirzaevilyosSpec: "Главной врач клиники",
    atayevShName: "Атаев Шухратжон Хасанович",
    atayevShSpec: "Лазерный хирург",
    doctorTitle: "Бо Коршиносони Мо Шинос Шавед",
    meetDoctorsLinkText: "Ба ҳама табибон нигаред",
    ganievShName: "Ганиев Шерзод Джуракулович",
    ganievShSpec: "Кераторефракционный хирург",
    oripovOName: "Орипов Ойбек Улугбекович",
    oripovOSpec: "Кераторефракционный хирург",
    oripovaYName: "Орипова Ёқутхон Чориқуловна",
    oripovaYSpec: "Врач офтальмолог",
    eshniyozovZarifName: "Эшниёзов Зарифжон Шухрат ўгли",
    eshniyozovZarifSpec: "Врач офтальмолог",
    xasanovJasurName: "Хасанов Жасуржон Икромович",
    xasanovJasurSpec: "Врач офтальмолог",
    ibodullayevBektoshName: "Ибодуллаев Бектош Чориқул ўғли",
    ibodullayevBektoshSpec: "Врач офтальмолог",
  },
};
